import React from 'react';

const PlaceView: React.FC = () => {
    return (
        <>
      
        </>
    );
}

export default PlaceView;
